<template>
  <div class="first-module">
    <dl>
      <dt>
        {{ $t('message["1443"]') }}
      </dt>
      <dd>
        <p>{{ $t('message["1637"]') }}:</p>
        <p>1.{{ $t('message["892"]') }}</p>
        <p>2.{{ tips2[0] }}<b>{{ tips2[1] }}</b>{{ tips2[2] }}</p>
        <a
          class="down-btn"
          @click="handleDown"
        >{{ $t('message["1305"]') }}</a>
      </dd>
    </dl>
    <dl>
      <dt>
        {{ $t('message["266"]') }}
      </dt>
      <dd>
        <a-radio-group
          v-model="auditType"
          @change="onChangeAudit"
        >
          <a-radio
            :style="radioStyle"
            :value="1"
          >
            {{ $t('message["1206"]') }}
          </a-radio>
          <a-radio
            :style="radioStyle"
            :value="0"
          >
            {{ $t('message["143"]') }}
          </a-radio>
        </a-radio-group>
      </dd>
    </dl>
    <dl>
      <dt>
        {{ $t('message["959"]') }}
      </dt>
      <dd class="upload-box">
        <a-upload
          v-decorator="[
            `upload-file`,
            {
              rules: [{
                validator: validateFile
              }],
              initialValue: fileList
            },
          ]"
          class="clearfix"
          :action="action"
          :multiple="false"
          :headers="{'X-Requested-With': null}"
          accept=".xlsx, .cvs"
          :data="params"
          :file-list="fileList"
          :before-upload="beforeUpload"
          :remove="handleRemove"
          @change="handleChange"
          @preview="onPreview"
        >
          <a-button :disabled="fileList.length >= 1">
            <a-icon type="upload" />{{ $t('message["993"]') }}
          </a-button>
          <!-- <span
            class="fs-gray"
          >支持20M以内的文件上传</span> -->
        </a-upload>
      </dd>
    </dl>
    <div class="footer">
      <a-button
        type="primary"
        :disabled="disabled"
        @click="createImport"
      >
        {{ $t('message["1300"]') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { upyunUpload, apiDomain } from '@/lib/config'
import { uploadSignature } from '@/services/index'
import { getBulkImportTemplateUrl } from '@/services/config'

export default {
  data () {
    return {
      auditType: 1,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      action: upyunUpload,
      params: {
        policy: '',
        signature: '',
        file: []
      },
      fileList: [],
      fileUrls: []
    }
  },

  computed: {
    count () {
      return this.$route.query.count || '1'
    },
    disabled () {
      let res = false
      if (this.fileList.length !== 1) {
        res = true
      } else if (!this.fileList[0].file_url) {
        res = true
      } else {
        res = false
      }

      return res
    },
    tips2 () {
      return this.$t('message["738"]').split('|')
    }
  },

  methods: {
    ...mapActions('config/batchImport', ['bulkImportAdd']),
    handleDown () {
      // let excelFile = 'https://static.westartrack.com/%E6%98%9F%E8%BD%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      /* const { protocol } = window.location
      if (protocol.indexOf('https') > -1) { // 线上环境
        excelFile = 'https://static.westartrack.com/v1/excel/导入模板.xlsx'
      } else { // 测试环境
        excelFile = 'http://work.dev.westartrack.com:93/excel/导入模板.xlsx'
      } */
      // window.open(excelFile)
      // this.$windowOpen(excelFile)

      /* let url = `${apiDomain}/inquiry/import/template`
      this.$windowOpen(url) */

      getBulkImportTemplateUrl()
        .onSuccess(payload => {
          if (payload && payload.url) {
            this.$windowOpen(apiDomain + payload.url)
          }
        })
        .fetch()
    },
    onChangeAudit (e) {
      let val = e.target.value
      this.auditType = val
    },
    handleChange (info) {
      // console.log(info)
      let file = info.file
      let fileList = [...info.fileList]

      if (file.status === 'error') {
        let index = fileList.find(item => item.name === file.name)
        fileList = fileList.slice(index, 1)
      }
      if (file.status === 'done') {
        // console.log(info.file.name)
        this.$message.success(`${info.file.name} ${this.$t('message["1269"]')}`)
      }

      fileList = fileList.map((file, i) => {
        if (file.response) {
          let index = fileList.length - this.fileUrls.length
          if (i >= index) {
            file.file_name = file.name
            file.file_url = this.fileUrls[i - index]
            file.file_size = file.size
            file.file_type = file.type
            file.description = file.name
            file.href = file.file_url
            file.title = this.$t('message["1304"]')
          }
        }
        return file
      })

      this.fileList = fileList
    },
    async beforeUpload (file) {
      let vm = this
      return new Promise(async (resolve, reject) => {
        if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
          this.$message.error(this.$t('message["1267"]'))
          return reject(new Error(false))
        }
        if (vm.fileList.length >= 1) {
          this.$message.error(this.$t('message["1600"]'))
          return reject(new Error(false))
        }
        const chain = await uploadSignature()
        chain.config({
          tip: false
        })
          .params({
            'filename': [file.name] // 文件本地路径
          })
          .onSuccess(async ([data = {}]) => {
            const {
              policy,
              signature,
              domain,
              upyunurl,
              _upt
            } = data

            // vm.file_url = domain + _upt
            vm.domain = domain
            // vm.file_url = _upt
            vm.params.policy = policy
            vm.params.signature = signature
            vm.action = upyunurl

            vm.fileUrls.push(_upt)
            return resolve(true)
          })
          .fetch()
      })
    },
    handleRemove (file) {
      this.fileList = []
    },
    onPreview (file) {
      if (file.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            let url = file.url || file.file_url
            // window.open(this.domain + url)
            this.$downloadFile(this.domain + url)
          }
        })
      } else {
        let i = this.fileList.findIndex(item => item.file_url === file.file_url)

        this.$bus.$emit('getFileGallery', this.fileList, i)
      }
    },
    validateFile (rule, value, callback) {
      // console.log(value, this.fileList)
      if (this.fileList.length >= 1) {
        // eslint-disable-next-line standard/no-callback-literal
        callback(this.$t('message["1600"]'))
        return
      }
      callback()
    },
    async createImport () {
      let fileUrl = this.fileList[0].file_url || ''
      const chain = await this.bulkImportAdd({
        audit_status: this.auditType,
        file: fileUrl.split('?')[0]
        // file: '/file/ffba400798eb5f066d6f0c7922170cc2.xlsx'
        // file: '/file/5777192f37i4b890b921bu6eae4234bc.xlsx'
      })

      chain.onSuccess(payload => {
        this.$router.push({
          name: 'configImportSecond',
          query: {
            id: payload
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.first-module {
  padding: 0 32px;
  dl {
    margin-bottom: 24px;
  }
  dt {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: bold;
  }
  dd {
    padding: 0 32px;
    color: #666;
    line-height: 28px;
    b {
      font-weight: bold;
    }
  }
  .upload-box::v-deep {
    padding: 16px 32px;
    .ant-upload {
      float: left;
      .ant-btn {
        margin-right: 24px;
      }
    }
    .ant-upload-list {
      float: left;
      width: 428px;
      padding: 5px 0;
    }
    .ant-upload-list-item {
      margin-top: 0;
    }
  }

  .footer {
    margin: 0 32px 58px;
  }
}
</style>
